import {
  isInternational
} from '../global/_checkForInternational';

export const internationalScrollTo_FAQ = () => {
  let currentURL = window.location.href;
  if (isInternational()) {
    if (currentURL.indexOf('privacy-policy') > -1) {
      $('html,body').animate({
        scrollTop: $('#int-policies-notices-question-privacy-policy').offset().top - 20
      }, 500);
    } else if (currentURL.indexOf('policies-notices-question-california') > -1) {
      $('html,body').animate({
        scrollTop: $('.show-when-international #policies-notices-question-california').offset().top
      }, 500);
    }
  }
}